import { render, staticRenderFns } from "./extSurveyDetail.vue?vue&type=template&id=031d81fe&scoped=true&"
import script from "./extSurveyDetail.vue?vue&type=script&lang=js&"
export * from "./extSurveyDetail.vue?vue&type=script&lang=js&"
import style0 from "./extSurveyDetail.vue?vue&type=style&index=0&id=031d81fe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031d81fe",
  null
  
)

export default component.exports